import { render, staticRenderFns } from "./ScanSettings.vue?vue&type=template&id=605e1144&scoped=true"
import script from "./ScanSettings.vue?vue&type=script&lang=ts"
export * from "./ScanSettings.vue?vue&type=script&lang=ts"
import style0 from "./ScanSettings.vue?vue&type=style&index=0&id=605e1144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605e1144",
  null
  
)

export default component.exports